import { Image } from 'react-native';

/**
 * Récupère le ratio d'une image en fonction de son URL.
 * @param imageUrl URL de l'image
 * @returns Promise<number> - Le ratio width / height de l'image
 */
export const getImageAspectRatio = (imageUrl: string): Promise<number> => {
    return new Promise((resolve, reject) => {
        if (!imageUrl) {
            reject("Invalid image URL");
            return;
        }

        Image.getSize(
            imageUrl,
            (width, height) => {
                resolve(width / height);
            },
            (error) => {
                console.error("Error loading image:", error);
                reject(error);
            }
        );
    });
};
